/**
 * useDateFnsLocale Hook
 *
 * Returns the date-fns Locale object corresponding to the current i18next language.
 * Use this hook in any React component that calls date-fns format() or
 * formatDistanceToNow() to ensure localized output.
 *
 * Usage:
 *   const locale = useDateFnsLocale();
 *   format(date, 'EEEE d MMMM yyyy', { locale });
 */

import { useTranslation } from 'react-i18next';
import { Locale } from 'date-fns';
import { getDateFnsLocale } from '../i18n/dateFnsLocale';

export function useDateFnsLocale(): Locale {
  const { i18n } = useTranslation();
  return getDateFnsLocale(i18n.language);
}

export default useDateFnsLocale;
